import Axios, * as others from 'axios';
import React, { Component,useEffect,useState } from "react";
import URL from '../../Environment';

const Maxdownload = () => {

  const countDownloadForm = (fileid) => {

    const fetchCountFormData = async () => {
      console.log(fileid);
      try {
        const response = await Axios.post(URL + 'api/DownloadForm/CountDownloadForm', {
          id: fileid,
        });
  
        //console.log(response);
      } catch (err) {
        console.log(err);
      }
    };

    // เรียกใช้งาน fetchData เมื่อค่าตัวแปร count มีการเปลี่ยนแปลง
    fetchCountFormData();
      
    // Cleanup function ที่จะถูกเรียกเมื่อ component ถูก unmount
    return () => {
      // ทำการคืนการทำงานที่ต้องการ (cleanup)
      //console.log('Component unmounted');
    };
  }

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {

  const fetchData = async () => {
    // try {

      Axios.get(URL + 'api/DownloadForm/GetDownloadformInterestMax').then((response) => {
        const res = response.data;
        //console.log(res);

        setData(response.data);
        setLoading(false);   

      }).catch((error) => {
        setError(error);
        setLoading(false); 
      });
  };

  // เรียกใช้งาน fetchData เมื่อค่าตัวแปร count มีการเปลี่ยนแปลง
  fetchData();

  // Cleanup function ที่จะถูกเรียกเมื่อ component ถูก unmount
  return () => {
    // ทำการคืนการทำงานที่ต้องการ (cleanup)
    //console.log('Component unmounted');
  };

  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (

    <aside className="widget-post">
    <h2 className="widget-title">ดาวน์โหลดมากที่สุด</h2>
    {
        data.map((form, index) => (
        <div className="item-recent clearfix" key={index}>
          <img src={`Img/Board/${index + 1}.png`} style={{ width: "50px" }} alt="Popular Form" />
          <h3 className="title">
            <a href={form.link} target="_blank" rel="noopener noreferrer" style={{fontSize:'16px'}}
            onClick={() => countDownloadForm(form.id)}
            >{form.topicform}</a>
            <br />
            <i>
              <span style={{ fontSize: "14px" }}>{form.downloadtime}</span> <span style={{ fontSize: "14px" }}>ครั้ง</span>
            </i>
          </h3>
        </div>
    ))
    }
    </aside>
        
  );
};



export default Maxdownload;
